import type {SettleQuixxsSessionRequestDto} from '@generated/models'

export type {
  CreateQuixxsSessionRequestDto as CreateQuixxsSessionRequest,
  QuixxsCreditsResponseDto as QuixxsCreditsResponse,
  QuixxsRecordingPolicyDto as QuixxsRecordingPolicy,
  QuixxsSessionResponseDto as QuixxsSessionCredentials,
  QuixxsSessionStatusResponseDto as QuixxsSessionStatusResponse,
  SettleQuixxsSessionResponseDto as SettleQuixxsSessionResponse,
} from '@generated/models'

export {QuixxsSessionStatus} from '@generated/models'

// Mapped type so this satisfies Record<> constraints used by variable-URL mutations
// (OpenAPI-generated interfaces do not).
export type SettleQuixxsSessionRequest = {
  [K in keyof SettleQuixxsSessionRequestDto]: SettleQuixxsSessionRequestDto[K]
}

/** SDK / client-only — not part of the REST OpenAPI surface */
export type QuixxsEnvironment = 'QA' | 'UAT' | 'PROD'

export type QuixxsRegion = 'IRELAND' | 'UK' | 'GERMANY' | 'SWITZERLAND'

export type QuixxsRecordingState =
  | 'IDLE'
  | 'RECORDING'
  | 'PAUSED'
  | 'STOPPING'
  | 'STOPPED'
  | string

export type QuixxsSessionSettleParams = {
  cushlaSessionId: string
}

export type QuixxsSessionCompletedEvent = {
  cushlaSessionId: string
  appointmentId: string
  durationSeconds: number
}
